<form *ngIf='form as form' [formGroup]='form' autocomplete='off' novalidate>
  <fieldset>
    <div class='row'>
      <div class='col-12'>
        <legend>{{ label }}</legend>
      </div>
    </div>
    <br>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"startDate" as controlName'>
          <label [for]='controlName'>
            Data od *
          </label>
          <app-date-picker (change)="form.startDateChange($event)" [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"endDate" as controlName'>
          <label [for]='controlName'>
            Data do *
          </label>
          <app-date-picker (change)="form.endDateChange($event)" [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-4">
        <div class='form-group' *ngIf='"dayQuantity" as controlName'>
          <label [for]='controlName'>
            Ilość dni
          </label>
          <input
            readonly
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Ilość dni'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <br>
    <app-exposed-map-control [control]="form.geometry">
    </app-exposed-map-control>
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-0 mt-3">
          <div class="custom-radio custom-inline">
            <input (change)="form.provideRoadNumberAndNameChange(true)" name="provideRoadNumberAndName"
                   formControlName="provideRoadNumberAndName" type="radio"
                   id="provideRoadNumberAndNameTrue" [value]="true">
            <label for="provideRoadNumberAndNameTrue">
              Chcę wprowadzić numer i nazwę drogi
            </label>
          </div>
          <div class="custom-radio custom-inline">
            <input (change)="form.provideRoadNumberAndNameChange(false)" name="provideRoadNumberAndName"
                   formControlName="provideRoadNumberAndName" type="radio"
                   id="provideRoadNumberAndNameFalse" [value]="false">
            <label for="provideRoadNumberAndNameFalse">
              Chcę wprowadzić ulicę
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            (change)="form.cityChange()"
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @if (form.provideRoadNumberAndName.value) {
              @for (item of townWithRoadsList(); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            } @else {
              @for (item of townWithStreetsList(); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.roadNumber) {
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"roadNumber" as controlName'>
            <label [for]='controlName'>
              Numer drogi *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              (change)="roadNumberChange(form.getElement($event).value)"
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of getRoadList(form.city.value); track $index) {
                <option [value]='item.roadNumber'>{{ item.roadNumber }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.roadName) {
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"roadName" as controlName'>
            <label [for]='controlName'>
              Nazwa drogi *
            </label>
            <input
              readonly
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę drogi'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.street) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of getStreetList(form.city.value); track $index) {
                <option [value]='item.roadNumber + " - " + item.name'>{{ item.roadNumber + " - " + item.name }}
                </option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <fieldset>
      <legend>
        Działki
      </legend>
      <div class="row">
        <div class="col-12">
          <app-parcels-crud formControlName="parcels"></app-parcels-crud>
        </div>
      </div>
    </fieldset>
    <br>
    <div class="row">
      <div class="col-12">
        <app-alert alertTitle="Uwaga!" type="info" [closable]="false">
          Wypełnij min <strong>1</strong> z poniższych sekcji.
        </app-alert>
      </div>
    </div>
    <fieldset>
      <legend>
        Jezdnia do 50% szerokości
      </legend>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadWidth2" as controlName'>
            <label [for]='controlName'>
              Szerokość (m)
            </label>
            <input
              (change)='form.calcRoadArea2()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu szerokość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadLength2" as controlName'>
            <label [for]='controlName'>
              Długość (m)
            </label>
            <input
              (change)='form.calcRoadArea2()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu długość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadArea2" as controlName'>
            <label [for]='controlName'>
              Powierzchnia (m<sup>2</sup>)
            </label>
            <input
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Powierzchnia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Jezdnia powyżej 50% szerokości
      </legend>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadWidth3" as controlName'>
            <label [for]='controlName'>
              Szerokość (m)
            </label>
            <input
              (change)='form.calcRoadArea3()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu szerokość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadLength3" as controlName'>
            <label [for]='controlName'>
              Długość (m)
            </label>
            <input
              (change)='form.calcRoadArea3()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu długość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadArea3" as controlName'>
            <label [for]='controlName'>
              Powierzchnia (m<sup>2</sup>)
            </label>
            <input
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Powierzchnia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Chodnik
      </legend>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"sidewalkWidth" as controlName'>
            <label [for]='controlName'>
              Szerokość (m)
            </label>
            <input
              (change)='form.calcSidewalkArea()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu szerokość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"sidewalkLength" as controlName'>
            <label [for]='controlName'>
              Długość (m)
            </label>
            <input
              (change)='form.calcSidewalkArea()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu długość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"sidewalkArea" as controlName'>
            <label [for]='controlName'>
              Powierzchnia (m<sup>2</sup>)
            </label>
            <input
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Powierzchnia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Pozostałe elementy drogi
      </legend>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"otherElementsWidth" as controlName'>
            <label [for]='controlName'>
              Szerokość (m)
            </label>
            <input
              (change)='form.calcOtherElementsArea()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu szerokość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"otherElementsLength" as controlName'>
            <label [for]='controlName'>
              Długość (m)
            </label>
            <input
              (change)='form.calcOtherElementsArea()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu długość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"otherElementsArea" as controlName'>
            <label [for]='controlName'>
              Powierzchnia (m<sup>2</sup>)
            </label>
            <input
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Powierzchnia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>W odniesieniu do obiektów i urządzeń infrastruktury telekomunikacyjnej</legend>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadWidth" as controlName'>
            <label [for]='controlName'>
              Szerokość (m)
            </label>
            <input
              (change)='form.calcRoadArea()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu szerokość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadLength" as controlName'>
            <label [for]='controlName'>
              Długość (m)
            </label>
            <input
              (change)='form.calcRoadArea()'
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu długość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"roadArea" as controlName'>
            <label [for]='controlName'>
              Powierzchnia (m<sup>2</sup>)
            </label>
            <input
              mask='separator.2'
              decimalMarker=','
              [dropSpecialCharacters]='false'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Powierzchnia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
  </fieldset>
</form>
